const FOCUS = [
  "Business ideas",
  "Offers",
  "Content",
  "Strategy",
  "Positioning",
  "Execution",
  "Networking",
  "Accountability",
];

export const WhatIsBuildDay = () => {
  return (
    <section
      id="about"
      data-testid="buildday-about-section"
      className="relative bg-[#0E0F12] py-24 md:py-40 border-t border-zinc-800"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-start">
          {/* Visual column */}
          <div className="md:col-span-6 reveal">
            <div className="relative aspect-[4/5] w-full overflow-hidden bg-[#15161B] border border-zinc-800">
              <img
                src="/media/buildday-poster.jpg"
                alt="Build Day Intensive in session"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <div className="absolute top-6 left-6 inline-flex items-center gap-2 border border-white/20 bg-black/50 backdrop-blur-sm px-3 py-1.5">
                <span className="w-1.5 h-1.5 bg-[#FCD34D]" />
                <span className="text-[10px] tracking-[0.3em] uppercase text-white font-bold">
                  In-Person · FMF Studio · London
                </span>
              </div>
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                <div>
                  <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-400 font-bold mb-2">
                    The Day
                  </div>
                  <div className="text-2xl md:text-3xl font-extrabold tracking-tighter text-white">
                    9AM → 5PM
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-400 font-bold mb-2">
                    Format
                  </div>
                  <div className="text-sm font-bold tracking-tight text-white">
                    Hands-On
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Copy column */}
          <div className="md:col-span-6">
            <div className="reveal flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#4F7CFF]" />
              <span className="text-xs tracking-[0.3em] uppercase text-[#4F7CFF] font-bold">
                What Is The Builders Sprint?
              </span>
            </div>
            <h2
              data-testid="buildday-about-headline"
              className="reveal text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-extrabold text-white leading-[1.05]"
            >
              A one-day <br />
              <span className="italic font-light text-white">
                transformation environment.
              </span>
            </h2>

            <div className="reveal mt-8 space-y-5 text-base md:text-lg leading-relaxed text-zinc-200 font-medium max-w-xl">
              <p>
                The Builders Sprint is built to help ambitious people change
                their trajectory in a single day. This is not another passive
                business seminar.
              </p>
              <p>
                It's a high-energy implementation environment where you work
                directly on your offer, content, strategy, positioning and
                execution — surrounded by people building at your level.
              </p>
              <p className="text-white font-semibold">
                Walk in unsure. Walk out with clarity, momentum and a real
                plan to act on.
              </p>
            </div>

            <div className="reveal mt-10 grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-xl">
              {FOCUS.map((tag) => (
                <div
                  key={tag}
                  className="flex items-center gap-2 text-zinc-300 text-sm border border-zinc-800 px-3 py-2"
                >
                  <span className="w-1 h-1 bg-[#4F7CFF]" />
                  <span className="tracking-tight font-medium">{tag}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
